import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class InventoryItemHdrQueryCriteriaClass extends BaseCriteriaModel {
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  guid_fi_mst_item?: Optional<string> = Optional.empty();
}

export class InventoryItemHdrCriteriaModelQuery {
  query = '';

  constructor( InventoryItemHdrCriteriaModel: InventoryItemHdrQueryCriteriaClass) {
    if (!InventoryItemHdrCriteriaModel) {
      return;
    }

    this.query += InventoryItemHdrCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += InventoryItemHdrCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += InventoryItemHdrCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += InventoryItemHdrCriteriaModel.guid_fi_mst_item.filter(x => x !== '').map(x => '&guid_fi_mst_item=' + x).orElse('');

    this.query += '&status=' + InventoryItemHdrCriteriaModel.status;
    this.query += '&orderBy=' + InventoryItemHdrCriteriaModel.orderBy;
    this.query += '&order=' + InventoryItemHdrCriteriaModel.order;
    this.query += '&offset=' + InventoryItemHdrCriteriaModel.offset + '&limit=' + InventoryItemHdrCriteriaModel.limit;
  }


}
